import { Button, Icon, Text } from '@southfields-digital/mpxlive-components';
import classnames from 'classnames';

import ActionButtons from 'src/components/ActionButtons';
import { IDisplayHubProps } from './types';

import styles from './DisplayHub.module.scss';

function DisplayHub(props: IDisplayHubProps) {
  const { variant, id, text, subText, icon = 'sort' } = props;

  const active = variant === 'static' ? false : props.active;
  const onClick = variant === 'static' ? () => {} : props.onClick;
  const onDuplicate = variant === 'static' ? () => {} : props.onDuplicate;
  const onDelete = variant === 'static' ? () => {} : props.onDelete;

  const showActionButtons = variant === 'static' ? false : true;

  return (
    <div className={classnames(styles.DisplayHub, { [styles.Active]: active })} key={id}>
      {variant === 'default' && (
        <div className="p-3.5 text-[#5B5D70]">
          <Icon icon={icon} weight="bold" />
        </div>
      )}
      <div className={styles.Content} onClick={onClick}>
        <div className={styles.Label}>
          <div className={styles.DisplayHubName}>
            <div className={styles.DisplayHubNameContent}>
              <Text as="p" lineClamp="clamp-1">
                {text}
              </Text>
            </div>
          </div>
        </div>
        {showActionButtons && (
          <div className={styles.Options}>
            <ActionButtons isActive={active} text={subText}>
              <Button iconProps={{ icon: 'copy' }} variant="secondary" onClick={onDuplicate} />
              <Button iconProps={{ icon: 'trash' }} variant="danger" onClick={onDelete} />
            </ActionButtons>
          </div>
        )}
      </div>
    </div>
  );
}

export default DisplayHub;
